import { render, staticRenderFns } from "./encase.vue?vue&type=template&id=4d7432a1"
import script from "./encase.vue?vue&type=script&lang=js"
export * from "./encase.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports